import React, { Component } from 'react';
import { connect } from 'react-redux';

import ForgotPasswordForm from '../components/Forms/ForgotPasswordForm.js';
import LoginChart from '../components/Forms/LoginChart';
import { forgotPasswordRequest } from '../actions';

import Logo from './../i/pickaxe.svg'

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit({ email }) {
    const { dispatch } = this.props;

    dispatch(forgotPasswordRequest({ email }));
  }

  getYear() {
    return new Date().getFullYear()
  }
  render() {

    return (
      <main className="login">
        <section className="login-left">
          <div className="login-beta">
            beta
          </div>
          <div className="login-intro">
            <a href="/" className="d-inline-block mb-5">
              <img src={Logo} alt="Pickaxe" className="login__logo" />
            </a>
            <h1 className="login-intro__title">
              It's your data. We just make it useful.
            </h1>
          </div>
          <div className="login-copyrights">
            @ {this.getYear()} Pickaxe Foundry, Inc
          </div>
        </section>
        <section className="login-right reset-form">
          <ForgotPasswordForm onSubmit={this.handleSubmit} />
          <LoginChart />
        </section>
      </main>
    );

  }
}

export default connect()(ForgotPasswordPage);
